@use '../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.profile{
  background: linear-gradient(180deg, rgb(140 138 138 / 88%) 0%, rgb(0 0 0 / 78%) 100%);
  border-radius:50%;
  width: 28px;
  height: 28px;
}